<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.purchases.retrieveLoader" transition="fade-transition" type="table"></v-skeleton-loader>
      <template v-else>
        <template v-if="list.length">
          <v-data-table :headers="headers" :items="list" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(list) => { goToUpdateorRetrieve(list) }" style="cursor: pointer">
            <!-- header -->
            <template v-slot:header="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.supplier`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.supplier.name}}</span>
            </template>
            <template v-slot:[`item.status`]="{item}">
              <v-row align="center" justify="end">
                <div class="text-right" v-if="showStatus">
                  <v-chip v-if="item.status === 'draft'" class="mx-1" color="defaultGrey" text-color="secondary" small>Borrador</v-chip>
                  <v-chip v-else-if="item.status === 'processing'" class="mx-1" color="defaultGrey" text-color="secondary" small>Procesando</v-chip>
                  <v-chip v-else-if="item.status === 'finalized'" class="mx-1" color="defaultGrey" text-color="secondary" small>Finalizado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                </div>
              </v-row>
            </template>
            <template v-slot:[`item.document`]="{item}">
              <span class="d-block">{{item.document.name}}</span>
              <span v-if="item.number !== 0" class="d-block body-2 text--secondary font-weight-medium">{{item.number}}</span>
            </template>
            <template v-slot:[`item.date`]="{item}">
              <span>{{item.date | date}}</span>
            </template>
            <template v-slot:[`item.total`]="{item}">
              <span class="body-2 text--secondary font-weight-medium">{{item.total | currency(item.currency)}}</span>
              <span class="ml-1">{{item.currency}}</span>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
        <v-row v-else>
          <v-col class="text-center py-5">
            <v-icon class="d-block" color="secondary" size="70">mdi-file</v-icon>
            <span class="d-block subtitle-1">No existen compras</span>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Proveedor', value: 'supplier', class: 'font-weight-bold', sortable: true },
      { text: '', value: 'status' },
      { text: 'Documento', value: 'document' },
      { text: 'Fecha', value: 'date', sortable: true },
      { text: 'Total', value: 'total', width: 300, align: 'end', sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.purchases.purchasesCount,
    list: state => state.purchases.purchasesList
  }),
  methods: {
    goToUpdateorRetrieve (item) {
      if (item.status === 'draft' && (item.document.is_purshase && !item.document.is_sale)) {
        this.$router.push({
          name: 'PurchaseUpdate',
          params: {
            id: item.id
          }
        })
      } else {
        this.$router.push({
          name: 'PurchaseRetrieve',
          params: {
            id: item.id
          }
        })
      }
    }
  }
}
</script>